export const PLAN_COLORS = {
  free: "#94A3B8",
  professional: "#2563EB",
  business: "#0A0F1C",
  enterprise: "#C2410C",
};

export function KPI({ icon: Icon, label, value, sub, accent }) {
  return (
    <div className="border border-slate-200 bg-white rounded-lg p-5" data-testid={`kpi-${label.toLowerCase().replace(/\s/g, "-")}`}>
      <div className="flex items-center justify-between">
        <span className="text-xs font-semibold uppercase tracking-wider text-slate-400">{label}</span>
        <Icon size={17} className={accent} />
      </div>
      <div className="mt-2 font-mono text-2xl font-bold text-[#0A0F1C]">{value}</div>
      {sub && <div className="text-xs text-slate-400 mt-0.5">{sub}</div>}
    </div>
  );
}
